import React, { type PropsWithChildren } from "react";

import { ButtonCell } from "../../../ButtonCell";
import { createDisplayNameForButtonCellActionElement } from "../../utils/getDisplayName";
import { createTestIdForButtonCellActionElement } from "../../utils/getTestId";

const BUTTON_CELL_ACTION_LEFT_ADDON_TEST_ID =
    createTestIdForButtonCellActionElement("left-addon");

export const ButtonCellActionLeftAddon = ({ children }: PropsWithChildren) => {
    return (
        <ButtonCell.LeftAddon data-tsid={BUTTON_CELL_ACTION_LEFT_ADDON_TEST_ID}>
            {children}
        </ButtonCell.LeftAddon>
    );
};

ButtonCellActionLeftAddon.displayName =
    createDisplayNameForButtonCellActionElement("LeftAddon");
export default ButtonCellActionLeftAddon;
